<template>
  <Bar :chart-data="chartData" :chart-options="options" />
</template>

<script>
// TODO: このコンポーネントを無くして、直接vue-chart.jsを使うようにしてツリーシェイキングさせる
// https://vue-chartjs.org/migration-guides/#tree-shaking
import 'chart.js/auto'
import { Bar } from 'vue-chartjs'

export default {
  name: 'ChartBar',
  components: { Bar },
  props: ['options', 'chartData'],
}
</script>
